import angular from 'angular';
import {
  loaderService,
  reportsDataService,
  ssDialogService
} from 'app/services';
import {
  alerts,
  confirmDialog,
  actionIcon
} from 'app/components/global';
import reportPackageConfigReportParam from './reportPackageConfigReportParam';
import directive from './report-package-configuration-report.directive';
import controller from './report-package-configuration-report.controller';


export default angular.module('app.components.reports.packageReports.reportPackageConfigurationReport', [
  ssDialogService,
  alerts,
  confirmDialog,
  reportsDataService,
  loaderService,
  actionIcon,
  reportPackageConfigReportParam,
])
  .directive('prReportPackageConfigurationReport', directive)
  .controller('PRReportPackageConfigurationReportController', controller)
  .name;

console.log('app.components.reports.packageReports.reportPackageConfigurationReport created');
